"use strict";
// @todo delete unneeded functions
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePrefix = exports.removePostfix = exports.cloneArray = exports.sortByKey = exports.getStringCompareFunction = exports.fromObjectToArray = exports.fromArrayToObject = exports.findIndex = exports.safe = void 0;
function safe(list, empty) {
    if (empty === void 0) { empty = new Array(); }
    return Array.isArray(list) ? list : empty;
}
exports.safe = safe;
function findIndex(arr, cb) {
    if (!arr || arr.length === 0) {
        return -1;
    }
    var i = 0;
    var len = arr.length;
    while (i < len) {
        if (cb(arr[i], i)) {
            return i;
        }
        i++;
    }
    return -1;
}
exports.findIndex = findIndex;
var fromArrayToObject = function (array, keyField) {
    return safe(array).reduce(function (obj, item) {
        if (item) {
            obj[item[keyField]] = item;
        }
        return obj;
    }, {});
};
exports.fromArrayToObject = fromArrayToObject;
var fromObjectToArray = function (object) { return Object.keys(object).map(function (k) { return object[k]; }); };
exports.fromObjectToArray = fromObjectToArray;
var getStringCompareFunction = function (key, ignoreCase) {
    if (ignoreCase === void 0) { ignoreCase = false; }
    return function (a, b) {
        if (ignoreCase) {
            return a[key].toLowerCase().localeCompare(b[key].toLowerCase());
        }
        else {
            return a[key].localeCompare(b[key]);
        }
    };
};
exports.getStringCompareFunction = getStringCompareFunction;
var sortByKey = function (array, key, ignoreCase) {
    if (ignoreCase === void 0) { ignoreCase = false; }
    return array.sort((0, exports.getStringCompareFunction)(key, ignoreCase));
};
exports.sortByKey = sortByKey;
var cloneArray = function (array) {
    return array.map(function (a) { return (__assign({}, a)); });
};
exports.cloneArray = cloneArray;
var removePostfix = function (source, postfix) {
    var result = source;
    if (result && postfix && result.substr(-postfix.length) === postfix) {
        result = result.substr(0, result.length - postfix.length);
    }
    return result;
};
exports.removePostfix = removePostfix;
var removePrefix = function (source, prefix) {
    var result = source;
    if (result && prefix && result.indexOf(prefix, 0) === 0) {
        result = result.substr(prefix.length);
    }
    return result;
};
exports.removePrefix = removePrefix;
